import React from 'react'
import { Link } from 'react-router-dom'
import "./Project.css"

const Project = ({img, github, name, desc, alt, link}) => {
  return (
    <div className="project" >
        <div className="project__image">
            <img src={img} alt={alt} />
        </div>

        <div className="project__desc">
            <h1>{name}</h1>
            <p>{desc}</p>
        </div>

        <div className="project__links">
          <a href={link} target={"_blank"} >
            <button className="btn1">Demo ↗</button>
          </a>
          

          <a href={github} target="_blank">
            <button className="btn2">Code {"< />"}</button>
          </a>
        </div>

    </div>
  )
}

export default Project